import { MutationTree } from 'vuex'
import { State } from '.'
import { IEntity } from '../interfaces/entity.interface'

const mutations: MutationTree<any> = {
	'setEntity'(state: State, payload: IEntity) {
		state.entity = payload
	},
	'setBackupEntity'(state: State, payload: IEntity) {
		state.backupEntity = payload
	},
	'updateEntity'(state: State, payload: IEntity | null) {
		state.entity = payload
	},
	'setQuestions'(state: State, payload: any) {
		state.questions = payload
	},
	'setPrivacyStatementSelected'(state: State, payload: boolean) {
		state.privacyStatementSelected = payload
	}
}

export default mutations
